var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"itemBody"},[_c('titleInfo',{attrs:{"title":_vm.title},on:{"getHide":_vm.getHide}}),_c('div',{staticClass:"itemBodyMain"},[_c('echarts')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }